import * as React from 'react';
import './TaskTypesPage.scss';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as TaskTypeActions from '../../../actions/taskTypes';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { QALookupsLayout } from '../../index';
interface ITaskTypesPageProps {
  location: Location;
  history: History;

  // From state
  formFilter: IFormFilter;
  taskTypes: Dtos.TaskType[];
  loadingTaskTypes: boolean;
  loadTaskTypesSuccess: boolean;
  loadTaskTypesFailure: boolean;
  user: Dtos.User;
  permissions?: Dtos.PersonnelTmdPermissions[];
  formRoles?: Dtos.RoleType[];
}
interface ITaskTypesPageActions {
  clearTaskTypes: TaskTypeActions.ITaskTypeClearActionCreator;
  loadTaskTypes: TaskTypeActions.ITaskTypeLoadActionCreator;
  navigate: typeof routerActions.push;
  navigateReplace: typeof routerActions.replace;
  filter: TaskTypeActions.ITaskTypeFilterActionCreator;
}
type TaskTypesPageProps = ITaskTypesPageProps & ITaskTypesPageActions;
class TaskTypesPage extends React.PureComponent<TaskTypesPageProps, any> {
  constructor(props: TaskTypesPageProps) {
    super(props);
    this.clearTaskTypes = this.clearTaskTypes.bind(this);
  }
  componentDidMount() {
    const {
      loadTaskTypes
    } = this.props;
    loadTaskTypes();
  }
  componentWillReceiveProps(nextProps: TaskTypesPageProps) {}
  componentDidUpdate(prevProps: TaskTypesPageProps, prevState) {
    const {
      navigateReplace
    } = this.props;
  }
  componentWillUpdate(nextProps: TaskTypesPageProps) {}
  componentWillUnmount() {
    this.clearTaskTypes();
  }
  clearTaskTypes() {
    this.props.clearTaskTypes();
  }
  showTaskTypes(): boolean {
    const {
      loadingTaskTypes,
      loadTaskTypesSuccess
    } = this.props;
    if (!loadingTaskTypes && loadTaskTypesSuccess) {
      return true;
    }
    return false;
  }
  render() {
    const {
      loadingTaskTypes
    } = this.props;
    return <QALookupsLayout loading={loadingTaskTypes} permission={Dtos.Permission.TaskTypesView} data-sentry-element="QALookupsLayout" data-sentry-component="TaskTypesPage" data-sentry-source-file="TaskTypesPage.tsx">
            {this.renderContent()}
        </QALookupsLayout>;
  }
  renderContent() {
    const {
      permissions
    } = this.props;
    return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Task Types</h2>
                </div>
                <div className="col-6" style={{
          textAlign: 'right'
        }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e)} />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TaskTypesCreate) && <Link className={"btn btn-primary"} url={"/settings/qa/taskTypes/create"}>Create</Link>}
                </div>
            </div>
            {!this.showTaskTypes() ? "Loading TaskTypes" : null}
            {this.showTaskTypes() ? <div className="patient-tables mt-2">
                        {this.createTable()}
                    </div> : null}
        </div>;
  }
  createTable() {
    const {
      taskTypes
    } = this.props;
    if (!taskTypes || taskTypes.length == 0) {
      return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no taskTypes to view.</span>
            </div>;
    }
    const showPagination = taskTypes.length > DEFAULT_PAGE_SIZE;
    return <div className="table-wrapper mb-3">
            <ReactTable data={taskTypes} pageSizeOptions={PAGE_SIZE_OPTIONS} defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : taskTypes.length} pageSize={showPagination ? undefined : taskTypes.length} showPagination={showPagination} className="-striped -highlight -clickable mb-3" noDataText="There are currently no taskType to display" resizable={false} getTdProps={(state, rowInfo: RowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            const url: string = "/settings/qa/taskTypes/" + rowInfo.original.id;
            this.props.navigate(url);
            if (handleOriginal) {
              handleOriginal();
            }
          },
          style: {
            color: rowInfo && rowInfo.original && rowInfo.original.active ? '#212529' : '#9e9e9e'
          }
        };
      }} columns={[{
        id: "id",
        Header: ' ',
        accessor: "id",
        className: "d-flex align-items-center justify-content-center",
        maxWidth: 50,
        Cell: props => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
      }, {
        id: "value",
        Header: 'Name',
        accessor: 'value',
        className: "d-flex align-items-left justify-content-left",
        headerClassName: "text-left"
      }]} />
        </div>;
  }
}
const mapStateToProps = (state: ITmdState, ownProps: TaskTypesPageProps): ITaskTypesPageProps => {
  let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];
  return {
    history: ownProps.history,
    location: state.routing.location,
    formFilter: state.taskTypes.formFilter,
    taskTypes: state.taskTypes.formFilteredData,
    loadingTaskTypes: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Pending,
    loadTaskTypesSuccess: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Success,
    loadTaskTypesFailure: state.taskTypes.loadState && state.taskTypes.loadState.status == RequestState.Failure,
    user: state.user.data,
    permissions: permissions,
    formRoles: state.user.formRoles
  };
};
const mapDispatchToProps = (dispatch): ITaskTypesPageActions => {
  return {
    navigate: bindActionCreators(routerActions.push, dispatch),
    navigateReplace: bindActionCreators(routerActions.replace, dispatch),
    loadTaskTypes: bindActionCreators(TaskTypeActions.LoadTaskType, dispatch),
    clearTaskTypes: bindActionCreators(TaskTypeActions.Clear, dispatch),
    filter: bindActionCreators(TaskTypeActions.Filter, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TaskTypesPage);